module.exports = __webpack_public_path__ + "static/media/Vicostone.7fcbb0ea.jpg";